import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';

import isMobile from 'shared/util/mobile.js';
import constants from '../util/constants.js';
import savedSearchActions from '../state/savedSearchActions.js';

import SavedSearchModal from './SavedSearchModal.jsx';

export class SavedSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            notifications: true,
        };
    }

    getFilterState() {
        const out = Object.assign({}, this.props.filterState);

        if (out[constants.AIRLINES] === '*') {
            delete out[constants.AIRLINES];
        }
        return out;
    }

    getSavedSearchParams() {
        return Object.assign({}, this.props.request, this.getFilterState(), { notifications: this.state.notifications });
    }

    handleToggleModalClick() {
        this.props.dispatch(savedSearchActions.toggleModal());
    }

    handleSaveChangesClick() {
        this.props.dispatch(savedSearchActions.saveSearch(this.getSavedSearchParams()));
    }

    handleSaveSearchClick(name) {
        const nameOverride = name ? { savedSearchName: name } : {};
        const params = Object.assign({}, this.getSavedSearchParams(), nameOverride);
        delete params.savedSearchId;

        this.props.dispatch(savedSearchActions.saveSearch(params));
    }

    handleNotificationsToggle() {
        this.setState({ notifications: !this.state.notifications });
    }

    render() {
        const savedSearchExists = !!this.props.filterState.savedSearchId;
        return (
            <>
                {isMobile() ? (
                    <button
                        className="button button--default button--small u-ma16 u-mr0"
                        data-testid="save-search"
                        disabled={!this.props.enabled}
                        onClick={this.handleToggleModalClick.bind(this)}>
                        {this.props.t('savedSearch.buttonTitle')}
                    </button>
                ) : (
                    <div className="u-pr32" data-testid="save-search-box">
                        {this.props.isLoggedIn && savedSearchExists ? (
                            <>
                                <span
                                    className={classNames('u-mb8 u-display-inline-block', {
                                        'u-d1': !savedSearchExists,
                                    })}
                                    data-testid="existing-saved-search">
                                    {this.props.t('savedSearch.showing')}
                                </span>
                                <div>
                                    &laquo;
                                    <b data-testid="saved-search-name">{this.props.name}</b>
                                    &raquo;
                                </div>
                                <button
                                    className="button button-default u-size1of1 u-mt8"
                                    data-testid="save-new-search"
                                    onClick={this.handleToggleModalClick.bind(this)}>
                                    {this.props.t('savedSearch.saveAsNew')}
                                </button>
                                {this.props.unsavedChanges && (
                                    <>
                                        <div className="u-pt16 u-pb8">{this.props.t('savedSearch.filtersChanged')}</div>
                                        <div>
                                            <button
                                                className="button button--cta u-size1of1"
                                                data-testid="save-changes"
                                                onClick={this.handleSaveChangesClick.bind(this)}>
                                                {this.props.t('savedSearch.saveChanges')}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <button
                                    className="button button--default u-size1of1"
                                    data-testid="save-search"
                                    onClick={this.handleToggleModalClick.bind(this)}
                                    disabled={!this.props.enabled || this.props.searchWasSaved}>
                                    {this.props.t('savedSearch.boxTitle')}
                                </button>
                                <span className="u-mt8 u-mb8 u-display-inline-block u-d1" data-testid="saved-search-intro">
                                    {this.props.t('savedSearch.boxIntro')}
                                </span>
                            </>
                        )}
                    </div>
                )}
                <div data-testid="save-search-modal-container">
                    {this.props.showModal && (
                        <SavedSearchModal
                            name={this.props.name}
                            notifications={this.state.notifications}
                            onCancelClick={this.handleToggleModalClick.bind(this)}
                            onSaveClick={this.handleSaveSearchClick.bind(this)}
                            onNotificationsToggle={this.handleNotificationsToggle.bind(this)}
                            isExistingSavedSearch={isMobile() && savedSearchExists}
                            hasChanged={this.props.unsavedChanges}
                            isLoggedIn={this.props.isLoggedIn}
                            t={this.props.t}
                        />
                    )}
                </div>
            </>
        );
    }
}

SavedSearch.propTypes = {
    enabled: PropTypes.bool.isRequired,
    showModal: PropTypes.bool.isRequired,
    unsavedChanges: PropTypes.bool.isRequired,
    searchWasSaved: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    request: PropTypes.object.isRequired,
    filterState: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    enabled: state.savedSearch.enabled,
    showModal: state.savedSearch.showModal,
    unsavedChanges: state.savedSearch.unsavedChanges,
    searchWasSaved: state.savedSearch.searchWasSaved,
    name: state.savedSearch.name,
    request: state.request,
    filterState: state.filterState,
});

export default connect(mapStateToProps)(withTranslation()(SavedSearch));
